import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import PageBlock from 'app/shared/componentsRestyled/common/PageBlock';
import { TableCDS } from 'app/shared/componentsRestyled/coreDesignSystem/Table';
import withLoading, { WithLoadingPropTypes } from 'hocs/withLoading';
import { compose } from 'redux';

import usePendingChangesDependentFetch from 'hooks/usePendingChangesDependentFetch';

import { getApplicationConsentsAction } from 'store/loanApplications/actions';
import { selectConsentTableData } from 'store/loanApplications/selectors';

import { consentTableConfig } from './Consent.config';

const Consent = ({ isLoading, setIsLoading }) => {
  const dispatch = useDispatch();
  const { applicationId } = useParams();

  const tableData = useSelector(selectConsentTableData);

  const fetchData = useCallback(() => {
    setIsLoading(true);

    dispatch(getApplicationConsentsAction({ applicationId }))
      .catch(Error)
      .finally(() => {
        setIsLoading(false);
      });
  }, [dispatch, applicationId, setIsLoading]);

  usePendingChangesDependentFetch(fetchData);

  return (
    <PageBlock withDivider title="Consent">
      <TableCDS
        withNoAvailableMessage
        config={consentTableConfig}
        data={tableData}
        isLoading={isLoading}
        skeletonRows={3}
      />
    </PageBlock>
  );
};

Consent.propTypes = {
  ...WithLoadingPropTypes,
};

export default compose(withLoading, memo)(Consent);
